import React from 'react'
import cssModules from 'react-css-modules'
import styles from './no_chip_in.less'
import { getI18n } from 'client/i18n'
import { exitGlimpse } from 'lib/glimpse'
import { routerShape } from 'react-router/lib/PropTypes'

const i18n = getI18n('components/chip_in_glimpse/no_chip_in')

class ChipInComplete extends React.Component {
  static propTypes = {
    router: routerShape.isRequired,
  }

  onOk = () => {
    exitGlimpse('chip_in', this.props.router)
  }

  render() {
    return (
      <div>
        <div styleName="title">{i18n('title')}</div>
        <div styleName="subtitle">{i18n('subtitle')}</div>
        <button
          className="vx_btn vx_btn-block vx_btn-secondary"
          styleName="ok-button"
          onClick={this.onOk}
        >
          {i18n('ok')}
        </button>
      </div>
    )
  }
}

export default cssModules(ChipInComplete, styles)
